import {
  API,
  GET_NEW_STORIES,
  GET_SERVICES,
  GET_USER_ID,
  SEND_SELECTED_SERVICES,
  GET_CLIENT_CARD,
  GET_BALANCE,
  GET_SUBSCRIPTION_INFO,
  GET_UNSUBSCRIBE_REASONS,
  STOP_AND_UNSUBSCRIBE,
  GET_ABONENT_INFO,
  START_SUBSCRIPTION,
  POST_USER_EVENT,
  RESUME_SUBSCRIPTION,
  GET_ALL_SERVICES,
  SUBSCRIPTION_TYPE_ID,
  GET_CAMERA_LIST,
  GET_INTERCOM_VIDEO,
  GET_USER_LOCATION,
} from "./Constants";

export async function fetchRequest(url, method = "GET", headers) {
  return await fetch(url, {
    method: method,
    headers: headers ?? {
      Authorization: `Bearer ${API.TOKEN}`,
    },
  })
    .then(async (data) => {
      if (data.status === 200) {
        return data.json();
      } else throw new Error(await data.text());
    })
    // eslint-disable-next-line no-console
    .catch(console.error);
}

export async function fetchImgRequest(url, method = "GET", headers) {
  return await fetch(url, {
    method: method,
    headers: headers ?? {
      Authorization: `Bearer ${API.TOKEN}`,
    },
  })
}

export async function fetchPostRequest(url, bodyObj, response = "data") {
  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${API.TOKEN}`,
      "content-type": "application/json",
    },
    body: JSON.stringify(bodyObj),
  })
    .then(async (data) => {
      if (data.status === 200) {
        return response === "status" ? true : data.json();
      } else throw new Error(await data.text());
    })
    // eslint-disable-next-line no-console
    .catch(console.error);
}

export const getUserInfo = async () => await fetchRequest(GET_USER_ID());

export const getPlansApi = async () => await fetchRequest(GET_SERVICES());

export const getClientCard = async () => await fetchRequest(GET_CLIENT_CARD());

export const getClientBalance = async () => await fetchRequest(GET_BALANCE());

export const getSubscriptionInfo = async () =>
  await fetchRequest(GET_SUBSCRIPTION_INFO());

export const getUnsubscribeReasons = async () =>
  await fetchRequest(GET_UNSUBSCRIBE_REASONS());

export const getAbonentInfo = async () =>
  await fetchRequest(GET_ABONENT_INFO());

export const stopAndUnsubscribe = async (reasonId) =>
  await fetchPostRequest(STOP_AND_UNSUBSCRIBE(), {
    typeId: SUBSCRIPTION_TYPE_ID,
    reasonId,
  });

export const resumeSubscription = async () =>
  await fetchRequest(RESUME_SUBSCRIPTION(), "PUT");

export const getNewStoriesApi = async () =>
  await fetchRequest(GET_NEW_STORIES());

export const postUserEvent = async (event, headers) => {
  return await fetch(POST_USER_EVENT(), {
    method: "POST",
    headers: Object.assign(
    {
      "Authorization": `Bearer ${API.TOKEN}`,
      "content-type": "application/json",
      "X-Api-Source": "com.intersvyaz.lk",
    }, headers
    ),
    body: JSON.stringify({"event_name": event}),
  })
    .then(async (data) => {
      if (data.status === 200) {
        return true;
      } else throw new Error(await data.text());
    })
    // eslint-disable-next-line no-console
    .catch(console.error);
};

export const sendSelectedServices = async (bodyObj) =>
  await fetchPostRequest(SEND_SELECTED_SERVICES(), bodyObj, "status");

export const postActivateSubscribe = async (bodyObj) =>
  await fetchPostRequest(START_SUBSCRIPTION(), bodyObj);

export const getAllServices = async () =>
  await fetchRequest(GET_ALL_SERVICES());

export const getCameraList = async () => await fetchRequest(GET_CAMERA_LIST());

export const getIntercomVideo = async (id) => await fetchImgRequest(GET_INTERCOM_VIDEO(id));

export const getUserLocation = async () => await fetchRequest(GET_USER_LOCATION());